import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import template from "./qb-info.template.vue";
import { IWorkOrderFilter, IQbInfo } from '@/interfaces';
import { makeWorkOrderFilter } from '@/utils';


@Component({
	mixins: [template]
})
export default class QbInfoComponent extends Vue {

	@Prop()public info!: IQbInfo;

}


  